import { AUTH_HEADER_CLASS, AUTH_SUBTITLE_CLASS, AUTH_TITLE_CLASS } from "./authClasses";

import { cn } from "@/utils";
import { ReactNode } from "react";

export type TAuthPageProps = {
  title: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
};

export function AuthPage({ title, subtitle, children, className }: TAuthPageProps) {
  return (
    <div className={cn("text-left", className)}>
      <div className={AUTH_HEADER_CLASS}>
        <h1 className={AUTH_TITLE_CLASS}>{title}</h1>
        {subtitle ? <p className={AUTH_SUBTITLE_CLASS}>{subtitle}</p> : null}
      </div>
      <div className="mt-6 sm:mt-8">{children}</div>
    </div>
  );
}
